// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: 7Fu6fQ1ynQ
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import ProjectTitleEditor from "../../ProjectTitleEditor"; // plasmic-import: etl2j9Ayu-/component
import TransparentDisplay from "../../TransparentDisplay"; // plasmic-import: BlxA_E123Ds/component
import CanvasSidebar from "../../CanvasSidebar"; // plasmic-import: vzjYCBMgG9/component
import NoteList from "../../NoteList"; // plasmic-import: WLg0i0UB0fg/component
import ControlHelper from "../../ControlHelper"; // plasmic-import: A1JWU10bpF/component
import LevelsMenu from "../../LevelsMenu"; // plasmic-import: KQlZmB74u86/component
import ListElement from "../../ListElement"; // plasmic-import: gZQS8RDUPA/component
import ProjectSettings from "../../ProjectSettings"; // plasmic-import: puuCzCTMd1/component
import WaitlistForm from "../../WaitlistForm"; // plasmic-import: 8REKzIRTXO/component
import NoteViewer from "../../NoteViewer"; // plasmic-import: 4ZvwFlOA8Z/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicCanvasView.module.css"; // plasmic-import: 7Fu6fQ1ynQ/css

import UploadSvgrepoComsvgIcon from "./icons/PlasmicIcon__UploadSvgrepoComsvg"; // plasmic-import: o-65aQViXW/icon
import FileSvgrepoCom2SvgIcon from "./icons/PlasmicIcon__FileSvgrepoCom2Svg"; // plasmic-import: ap2PXUMiGo/icon
import imageWlrG2Qk0Ne9 from "./images/image.svg"; // plasmic-import: wlrG2qk0ne9/picture

export type PlasmicCanvasView__VariantMembers = {
  state:
    | "noteEditor"
    | "settings"
    | "levels"
    | "noteList"
    | "waitList"
    | "spaces"
    | "googleDrivePreview";
  noFile: "noFile";
  showLevel: "showLevel";
  showSpace: "showSpace";
};

export type PlasmicCanvasView__VariantsArgs = {
  state?: MultiChoiceArg<
    | "noteEditor"
    | "settings"
    | "levels"
    | "noteList"
    | "waitList"
    | "spaces"
    | "googleDrivePreview"
  >;
  noFile?: SingleBooleanChoiceArg<"noFile">;
  showLevel?: SingleBooleanChoiceArg<"showLevel">;
  showSpace?: SingleBooleanChoiceArg<"showSpace">;
};

type VariantPropType = keyof PlasmicCanvasView__VariantsArgs;
export const PlasmicCanvasView__VariantProps = new Array<VariantPropType>(
  "state",
  "noFile",
  "showLevel",
  "showSpace"
);

export type PlasmicCanvasView__ArgsType = {
  children?: React.ReactNode;
  children2?: React.ReactNode;
};

type ArgPropType = keyof PlasmicCanvasView__ArgsType;
export const PlasmicCanvasView__ArgProps = new Array<ArgPropType>(
  "children",
  "children2"
);

export type PlasmicCanvasView__OverridesType = {
  root?: p.Flex<"div">;
  projectTitleEditor?: p.Flex<typeof ProjectTitleEditor>;
  levelDisplay?: p.Flex<typeof TransparentDisplay>;
  spaceDisplay?: p.Flex<typeof TransparentDisplay>;
  toProjects?: p.Flex<"div">;
  projects?: p.Flex<"div">;
  logo?: p.Flex<typeof p.PlasmicImg>;
  pro?: p.Flex<"div">;
  subscription?: p.Flex<"div">;
  columns?: p.Flex<"div">;
  canvasSidebar?: p.Flex<typeof CanvasSidebar>;
  noteList?: p.Flex<typeof NoteList>;
  controlHelper?: p.Flex<typeof ControlHelper>;
  grayMenuArea?: p.Flex<"div">;
  levelsMenu?: p.Flex<typeof LevelsMenu>;
  projectSettings?: p.Flex<typeof ProjectSettings>;
  noFileOptions?: p.Flex<"div">;
  fileUpload?: p.Flex<"div">;
  formats2?: p.Flex<"div">;
  createDemo?: p.Flex<"div">;
  waitlistForm?: p.Flex<typeof WaitlistForm>;
  googleDriveContainer?: p.Flex<"div">;
  googleDriveSheet?: p.Flex<"div">;
  canvasDiv?: p.Flex<"div">;
  noteViewer?: p.Flex<typeof NoteViewer>;
  toastify?: p.Flex<"div">;
};

export interface DefaultCanvasViewProps {
  children?: React.ReactNode;
  children2?: React.ReactNode;
  state?: MultiChoiceArg<
    | "noteEditor"
    | "settings"
    | "levels"
    | "noteList"
    | "waitList"
    | "spaces"
    | "googleDrivePreview"
  >;
  noFile?: SingleBooleanChoiceArg<"noFile">;
  showLevel?: SingleBooleanChoiceArg<"showLevel">;
  showSpace?: SingleBooleanChoiceArg<"showSpace">;
  className?: string;
}

function PlasmicCanvasView__RenderFunc(props: {
  variants: PlasmicCanvasView__VariantsArgs;
  args: PlasmicCanvasView__ArgsType;
  overrides: PlasmicCanvasView__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        {
          [sty.rootstate_noteEditor]: hasVariant(
            variants,
            "state",
            "noteEditor"
          )
        }
      )}
    >
      {true ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__jtyZf, {
            [sty.freeBoxnoFile__jtyZfmcGqc]: hasVariant(
              variants,
              "noFile",
              "noFile"
            ),
            [sty.freeBoxstate_googleDrivePreview__jtyZfEbA]: hasVariant(
              variants,
              "state",
              "googleDrivePreview"
            ),
            [sty.freeBoxstate_levels__jtyZfmF3Nh]: hasVariant(
              variants,
              "state",
              "levels"
            ),
            [sty.freeBoxstate_noteEditor__jtyZfs17XU]: hasVariant(
              variants,
              "state",
              "noteEditor"
            ),
            [sty.freeBoxstate_settings__jtyZfgMbjb]: hasVariant(
              variants,
              "state",
              "settings"
            ),
            [sty.freeBoxstate_spaces__jtyZftppIp]: hasVariant(
              variants,
              "state",
              "spaces"
            ),
            [sty.freeBoxstate_waitList__jtyZfyNvG4]: hasVariant(
              variants,
              "state",
              "waitList"
            )
          })}
        >
          <p.Stack
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__lm7PE, {
              [sty.freeBoxshowLevel__lm7PEhPhB6]: hasVariant(
                variants,
                "showLevel",
                "showLevel"
              )
            })}
          >
            {(hasVariant(variants, "noFile", "noFile") ? true : true) ? (
              <ProjectTitleEditor
                data-plasmic-name={"projectTitleEditor"}
                data-plasmic-override={overrides.projectTitleEditor}
                className={classNames(
                  "__wab_instance",
                  sty.projectTitleEditor,
                  {
                    [sty.projectTitleEditornoFile]: hasVariant(
                      variants,
                      "noFile",
                      "noFile"
                    ),
                    [sty.projectTitleEditorshowLevel]: hasVariant(
                      variants,
                      "showLevel",
                      "showLevel"
                    ),
                    [sty.projectTitleEditorshowSpace]: hasVariant(
                      variants,
                      "showSpace",
                      "showSpace"
                    ),
                    [sty.projectTitleEditorstate_googleDrivePreview]:
                      hasVariant(variants, "state", "googleDrivePreview"),
                    [sty.projectTitleEditorstate_levels]: hasVariant(
                      variants,
                      "state",
                      "levels"
                    ),
                    [sty.projectTitleEditorstate_noteEditor]: hasVariant(
                      variants,
                      "state",
                      "noteEditor"
                    ),
                    [sty.projectTitleEditorstate_settings]: hasVariant(
                      variants,
                      "state",
                      "settings"
                    ),
                    [sty.projectTitleEditorstate_spaces]: hasVariant(
                      variants,
                      "state",
                      "spaces"
                    ),
                    [sty.projectTitleEditorstate_waitList]: hasVariant(
                      variants,
                      "state",
                      "waitList"
                    )
                  }
                )}
              >
                {"Untitled"}
              </ProjectTitleEditor>
            ) : null}
            {(hasVariant(variants, "showLevel", "showLevel") ? true : true) ? (
              <TransparentDisplay
                data-plasmic-name={"levelDisplay"}
                data-plasmic-override={overrides.levelDisplay}
                className={classNames("__wab_instance", sty.levelDisplay, {
                  [sty.levelDisplayshowLevel]: hasVariant(
                    variants,
                    "showLevel",
                    "showLevel"
                  )
                })}
                showLevel={
                  hasVariant(variants, "showLevel", "showLevel")
                    ? true
                    : undefined
                }
              >
                {p.renderPlasmicSlot({
                  defaultContents: "First Floor",
                  value: args.children
                })}
              </TransparentDisplay>
            ) : null}
            {(
              hasVariant(variants, "showLevel", "showLevel")
                ? true
                : hasVariant(variants, "showSpace", "showSpace")
                ? true
                : false
            ) ? (
              <TransparentDisplay
                data-plasmic-name={"spaceDisplay"}
                data-plasmic-override={overrides.spaceDisplay}
                className={classNames("__wab_instance", sty.spaceDisplay, {
                  [sty.spaceDisplayshowLevel]: hasVariant(
                    variants,
                    "showLevel",
                    "showLevel"
                  ),
                  [sty.spaceDisplayshowSpace]: hasVariant(
                    variants,
                    "showSpace",
                    "showSpace"
                  )
                })}
                showLevel={
                  hasVariant(variants, "showLevel", "showLevel")
                    ? true
                    : undefined
                }
              >
                {p.renderPlasmicSlot({
                  defaultContents: "Space",
                  value: args.children2
                })}
              </TransparentDisplay>
            ) : null}
          </p.Stack>

          <div
            className={classNames(projectcss.all, sty.freeBox__rt1Y2, {
              [sty.freeBoxnoFile__rt1Y2McGqc]: hasVariant(
                variants,
                "noFile",
                "noFile"
              ),
              [sty.freeBoxstate_googleDrivePreview__rt1Y2EbA]: hasVariant(
                variants,
                "state",
                "googleDrivePreview"
              ),
              [sty.freeBoxstate_levels__rt1Y2MF3Nh]: hasVariant(
                variants,
                "state",
                "levels"
              ),
              [sty.freeBoxstate_spaces__rt1Y2TppIp]: hasVariant(
                variants,
                "state",
                "spaces"
              ),
              [sty.freeBoxstate_waitList__rt1Y2YNvG4]: hasVariant(
                variants,
                "state",
                "waitList"
              )
            })}
          >
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__yEfSy, {
                [sty.freeBoxnoFile__yEfSYmcGqc]: hasVariant(
                  variants,
                  "noFile",
                  "noFile"
                ),
                [sty.freeBoxshowLevel__yEfSYhPhB6]: hasVariant(
                  variants,
                  "showLevel",
                  "showLevel"
                ),
                [sty.freeBoxstate_googleDrivePreview__yEfSyEbA]: hasVariant(
                  variants,
                  "state",
                  "googleDrivePreview"
                ),
                [sty.freeBoxstate_levels__yEfSYmF3Nh]: hasVariant(
                  variants,
                  "state",
                  "levels"
                ),
                [sty.freeBoxstate_spaces__yEfSYtppIp]: hasVariant(
                  variants,
                  "state",
                  "spaces"
                ),
                [sty.freeBoxstate_waitList__yEfSYyNvG4]: hasVariant(
                  variants,
                  "state",
                  "waitList"
                )
              })}
            >
              {true ? (
                <div
                  data-plasmic-name={"toProjects"}
                  data-plasmic-override={overrides.toProjects}
                  className={classNames(projectcss.all, sty.toProjects)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__e8Rbj,
                      {
                        [sty.textnoFile__e8RbJmcGqc]: hasVariant(
                          variants,
                          "noFile",
                          "noFile"
                        ),
                        [sty.textstate_googleDrivePreview__e8RbjEbA]:
                          hasVariant(variants, "state", "googleDrivePreview"),
                        [sty.textstate_levels__e8RbJmF3Nh]: hasVariant(
                          variants,
                          "state",
                          "levels"
                        ),
                        [sty.textstate_settings__e8RbJgMbjb]: hasVariant(
                          variants,
                          "state",
                          "settings"
                        ),
                        [sty.textstate_spaces__e8RbJtppIp]: hasVariant(
                          variants,
                          "state",
                          "spaces"
                        ),
                        [sty.textstate_waitList__e8RbJyNvG4]: hasVariant(
                          variants,
                          "state",
                          "waitList"
                        )
                      }
                    )}
                  >
                    {"Projekte"}
                  </div>
                </div>
              ) : null}

              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__wOjLk)}
              >
                {true ? (
                  <div
                    data-plasmic-name={"projects"}
                    data-plasmic-override={overrides.projects}
                    className={classNames(projectcss.all, sty.projects)}
                  >
                    {true ? (
                      <p.PlasmicImg
                        data-plasmic-name={"logo"}
                        data-plasmic-override={overrides.logo}
                        alt={""}
                        className={classNames(sty.logo)}
                        displayHeight={"40px" as const}
                        displayMaxHeight={"none" as const}
                        displayMaxWidth={"none" as const}
                        displayMinHeight={"0" as const}
                        displayMinWidth={"0" as const}
                        displayWidth={"40px" as const}
                        src={{
                          src: imageWlrG2Qk0Ne9,
                          fullWidth: 150,
                          fullHeight: 150,
                          aspectRatio: 1
                        }}
                      />
                    ) : null}

                    <div
                      data-plasmic-name={"pro"}
                      data-plasmic-override={overrides.pro}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.pro
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"Projects"}
                        </span>
                      </React.Fragment>
                    </div>
                  </div>
                ) : null}

                <div className={classNames(projectcss.all, sty.freeBox__pwbq1)}>
                  <div
                    data-plasmic-name={"subscription"}
                    data-plasmic-override={overrides.subscription}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.subscription
                    )}
                  >
                    {"free"}
                  </div>
                </div>
              </p.Stack>
            </p.Stack>
          </div>

          {(hasVariant(variants, "noFile", "noFile") ? true : true) ? (
            <div
              data-plasmic-name={"columns"}
              data-plasmic-override={overrides.columns}
              className={classNames(projectcss.all, sty.columns, {
                [sty.columnsnoFile]: hasVariant(variants, "noFile", "noFile"),
                [sty.columnsstate_noteEditor]: hasVariant(
                  variants,
                  "state",
                  "noteEditor"
                )
              })}
            >
              <div
                className={classNames(projectcss.all, sty.column___2HVfd, {
                  [sty.columnstate_noteEditor___2HVfDs17XU]: hasVariant(
                    variants,
                    "state",
                    "noteEditor"
                  )
                })}
              >
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__dqeor)}
                >
                  {true ? (
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox__r9Ddz,
                        {
                          [sty.freeBoxstate_noteEditor__r9DdZs17XU]: hasVariant(
                            variants,
                            "state",
                            "noteEditor"
                          )
                        }
                      )}
                    >
                      <CanvasSidebar
                        data-plasmic-name={"canvasSidebar"}
                        data-plasmic-override={overrides.canvasSidebar}
                        className={classNames(
                          "__wab_instance",
                          sty.canvasSidebar,
                          {
                            [sty.canvasSidebarnoFile]: hasVariant(
                              variants,
                              "noFile",
                              "noFile"
                            ),
                            [sty.canvasSidebarstate_googleDrivePreview]:
                              hasVariant(
                                variants,
                                "state",
                                "googleDrivePreview"
                              ),
                            [sty.canvasSidebarstate_levels]: hasVariant(
                              variants,
                              "state",
                              "levels"
                            ),
                            [sty.canvasSidebarstate_noteEditor]: hasVariant(
                              variants,
                              "state",
                              "noteEditor"
                            ),
                            [sty.canvasSidebarstate_noteList]: hasVariant(
                              variants,
                              "state",
                              "noteList"
                            ),
                            [sty.canvasSidebarstate_settings]: hasVariant(
                              variants,
                              "state",
                              "settings"
                            ),
                            [sty.canvasSidebarstate_spaces]: hasVariant(
                              variants,
                              "state",
                              "spaces"
                            ),
                            [sty.canvasSidebarstate_waitList]: hasVariant(
                              variants,
                              "state",
                              "waitList"
                            )
                          }
                        )}
                        state={
                          hasVariant(variants, "noFile", "noFile")
                            ? ["settings"]
                            : hasVariant(
                                variants,
                                "state",
                                "googleDrivePreview"
                              )
                            ? ["spaces"]
                            : hasVariant(variants, "state", "spaces")
                            ? ["spaces"]
                            : hasVariant(variants, "state", "waitList")
                            ? ["levels"]
                            : hasVariant(variants, "state", "noteList")
                            ? ["noteList"]
                            : hasVariant(variants, "state", "levels")
                            ? ["levels"]
                            : hasVariant(variants, "state", "settings")
                            ? ["settings"]
                            : []
                        }
                      />
                    </div>
                  ) : null}
                  {(hasVariant(variants, "state", "noteList") ? true : true) ? (
                    <NoteList
                      data-plasmic-name={"noteList"}
                      data-plasmic-override={overrides.noteList}
                      className={classNames("__wab_instance", sty.noteList, {
                        [sty.noteListstate_noteList]: hasVariant(
                          variants,
                          "state",
                          "noteList"
                        )
                      })}
                    />
                  ) : null}
                </p.Stack>
              </div>

              <div className={classNames(projectcss.all, sty.column__xsdTc)}>
                {(hasVariant(variants, "state", "noteEditor") ? true : true) ? (
                  <ControlHelper
                    data-plasmic-name={"controlHelper"}
                    data-plasmic-override={overrides.controlHelper}
                    className={classNames("__wab_instance", sty.controlHelper, {
                      [sty.controlHelperstate_noteEditor]: hasVariant(
                        variants,
                        "state",
                        "noteEditor"
                      )
                    })}
                  />
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
      {(
        hasVariant(variants, "noFile", "noFile")
          ? true
          : hasVariant(variants, "state", "googleDrivePreview")
          ? true
          : hasVariant(variants, "state", "spaces")
          ? true
          : hasVariant(variants, "state", "waitList")
          ? true
          : hasVariant(variants, "state", "levels")
          ? true
          : hasVariant(variants, "state", "settings")
          ? true
          : false
      ) ? (
        <div
          data-plasmic-name={"grayMenuArea"}
          data-plasmic-override={overrides.grayMenuArea}
          className={classNames(projectcss.all, sty.grayMenuArea, {
            [sty.grayMenuAreanoFile]: hasVariant(variants, "noFile", "noFile"),
            [sty.grayMenuAreastate_googleDrivePreview]: hasVariant(
              variants,
              "state",
              "googleDrivePreview"
            ),
            [sty.grayMenuAreastate_levels]: hasVariant(
              variants,
              "state",
              "levels"
            ),
            [sty.grayMenuAreastate_noteEditor]: hasVariant(
              variants,
              "state",
              "noteEditor"
            ),
            [sty.grayMenuAreastate_settings]: hasVariant(
              variants,
              "state",
              "settings"
            ),
            [sty.grayMenuAreastate_spaces]: hasVariant(
              variants,
              "state",
              "spaces"
            ),
            [sty.grayMenuAreastate_waitList]: hasVariant(
              variants,
              "state",
              "waitList"
            )
          })}
        >
          {(
            hasVariant(variants, "noFile", "noFile")
              ? true
              : hasVariant(variants, "state", "googleDrivePreview")
              ? true
              : hasVariant(variants, "state", "waitList")
              ? true
              : hasVariant(variants, "state", "settings")
              ? true
              : true
          ) ? (
            <LevelsMenu
              data-plasmic-name={"levelsMenu"}
              data-plasmic-override={overrides.levelsMenu}
              className={classNames("__wab_instance", sty.levelsMenu, {
                [sty.levelsMenunoFile]: hasVariant(
                  variants,
                  "noFile",
                  "noFile"
                ),
                [sty.levelsMenustate_googleDrivePreview]: hasVariant(
                  variants,
                  "state",
                  "googleDrivePreview"
                ),
                [sty.levelsMenustate_settings]: hasVariant(
                  variants,
                  "state",
                  "settings"
                ),
                [sty.levelsMenustate_waitList]: hasVariant(
                  variants,
                  "state",
                  "waitList"
                )
              })}
              storiesList={
                <React.Fragment>
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement__zIxR
                      )}
                    >
                      {"Enter some text"}
                    </ListElement>
                  ) : null}
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement__d5Jyn
                      )}
                    >
                      {"Enter some text"}
                    </ListElement>
                  ) : null}
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement___9X99
                      )}
                    >
                      {"Enter some text"}
                    </ListElement>
                  ) : null}
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement__px44K
                      )}
                    >
                      {"Enter some text"}
                    </ListElement>
                  ) : null}
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement__mRFuW
                      )}
                    >
                      {"Enter some text"}
                    </ListElement>
                  ) : null}
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement__xz3XE
                      )}
                    >
                      {"Enter some text"}
                    </ListElement>
                  ) : null}
                  {true ? (
                    <ListElement
                      className={classNames(
                        "__wab_instance",
                        sty.listElement___9Ot1Q
                      )}
                    >
                      {"Enter some text"}
                    </ListElement>
                  ) : null}
                </React.Fragment>
              }
            />
          ) : null}
          {(
            hasVariant(variants, "noFile", "noFile")
              ? true
              : hasVariant(variants, "state", "settings")
              ? true
              : true
          ) ? (
            <ProjectSettings
              data-plasmic-name={"projectSettings"}
              data-plasmic-override={overrides.projectSettings}
              className={classNames("__wab_instance", sty.projectSettings, {
                [sty.projectSettingsnoFile]: hasVariant(
                  variants,
                  "noFile",
                  "noFile"
                ),
                [sty.projectSettingsstate_settings]: hasVariant(
                  variants,
                  "state",
                  "settings"
                )
              })}
            />
          ) : null}
          {(
            hasVariant(variants, "state", "googleDrivePreview")
              ? true
              : hasVariant(variants, "state", "spaces")
              ? true
              : hasVariant(variants, "state", "waitList")
              ? true
              : hasVariant(variants, "state", "levels")
              ? true
              : hasVariant(variants, "state", "settings")
              ? true
              : true
          ) ? (
            <div
              data-plasmic-name={"noFileOptions"}
              data-plasmic-override={overrides.noFileOptions}
              className={classNames(projectcss.all, sty.noFileOptions, {
                [sty.noFileOptionsnoFile]: hasVariant(
                  variants,
                  "noFile",
                  "noFile"
                ),
                [sty.noFileOptionsstate_googleDrivePreview]: hasVariant(
                  variants,
                  "state",
                  "googleDrivePreview"
                ),
                [sty.noFileOptionsstate_levels]: hasVariant(
                  variants,
                  "state",
                  "levels"
                ),
                [sty.noFileOptionsstate_settings]: hasVariant(
                  variants,
                  "state",
                  "settings"
                ),
                [sty.noFileOptionsstate_spaces]: hasVariant(
                  variants,
                  "state",
                  "spaces"
                ),
                [sty.noFileOptionsstate_waitList]: hasVariant(
                  variants,
                  "state",
                  "waitList"
                )
              })}
            >
              {(
                hasVariant(variants, "state", "googleDrivePreview")
                  ? true
                  : hasVariant(variants, "state", "spaces")
                  ? true
                  : hasVariant(variants, "state", "waitList")
                  ? true
                  : hasVariant(variants, "state", "levels")
                  ? true
                  : hasVariant(variants, "state", "settings")
                  ? true
                  : hasVariant(variants, "state", "noteEditor")
                  ? true
                  : true
              ) ? (
                <div
                  data-plasmic-name={"fileUpload"}
                  data-plasmic-override={overrides.fileUpload}
                  className={classNames(projectcss.all, sty.fileUpload, {
                    [sty.fileUploadnoFile]: hasVariant(
                      variants,
                      "noFile",
                      "noFile"
                    ),
                    [sty.fileUploadstate_googleDrivePreview]: hasVariant(
                      variants,
                      "state",
                      "googleDrivePreview"
                    ),
                    [sty.fileUploadstate_levels]: hasVariant(
                      variants,
                      "state",
                      "levels"
                    ),
                    [sty.fileUploadstate_noteEditor]: hasVariant(
                      variants,
                      "state",
                      "noteEditor"
                    ),
                    [sty.fileUploadstate_settings]: hasVariant(
                      variants,
                      "state",
                      "settings"
                    ),
                    [sty.fileUploadstate_spaces]: hasVariant(
                      variants,
                      "state",
                      "spaces"
                    ),
                    [sty.fileUploadstate_waitList]: hasVariant(
                      variants,
                      "state",
                      "waitList"
                    )
                  })}
                >
                  <UploadSvgrepoComsvgIcon
                    className={classNames(projectcss.all, sty.svg__rKr3C)}
                    role={"img"}
                  />

                  <div
                    className={classNames(projectcss.all, sty.freeBox___8H02V)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__opqxD
                      )}
                    >
                      {"Upload file to view it here "}
                    </div>

                    <div
                      className={classNames(projectcss.all, sty.freeBox__mCRxp)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___5VL8K
                        )}
                      >
                        {"Accepted Formats:  "}
                      </div>

                      <div
                        data-plasmic-name={"formats2"}
                        data-plasmic-override={overrides.formats2}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.formats2
                        )}
                      >
                        {".ifc, .glb, .obj, .fbx"}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              <p.Stack
                as={"div"}
                data-plasmic-name={"createDemo"}
                data-plasmic-override={overrides.createDemo}
                hasGap={true}
                className={classNames(projectcss.all, sty.createDemo, {
                  [sty.createDemonoFile]: hasVariant(
                    variants,
                    "noFile",
                    "noFile"
                  )
                })}
              >
                <FileSvgrepoCom2SvgIcon
                  className={classNames(projectcss.all, sty.svg___2NCwC)}
                  role={"img"}
                />

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__vF7W,
                    {
                      [sty.textnoFile__vF7WmcGqc]: hasVariant(
                        variants,
                        "noFile",
                        "noFile"
                      )
                    }
                  )}
                >
                  {"Open Demo-Project"}
                </div>
              </p.Stack>
            </div>
          ) : null}
          {(hasVariant(variants, "state", "waitList") ? true : true) ? (
            <WaitlistForm
              data-plasmic-name={"waitlistForm"}
              data-plasmic-override={overrides.waitlistForm}
              className={classNames("__wab_instance", sty.waitlistForm, {
                [sty.waitlistFormstate_waitList]: hasVariant(
                  variants,
                  "state",
                  "waitList"
                )
              })}
            />
          ) : null}
          {(
            hasVariant(variants, "state", "googleDrivePreview") ? true : true
          ) ? (
            <div
              data-plasmic-name={"googleDriveContainer"}
              data-plasmic-override={overrides.googleDriveContainer}
              className={classNames(projectcss.all, sty.googleDriveContainer, {
                [sty.googleDriveContainerstate_googleDrivePreview]: hasVariant(
                  variants,
                  "state",
                  "googleDrivePreview"
                )
              })}
            >
              <div
                data-plasmic-name={"googleDriveSheet"}
                data-plasmic-override={overrides.googleDriveSheet}
                className={classNames(projectcss.all, sty.googleDriveSheet, {
                  [sty.googleDriveSheetstate_googleDrivePreview]: hasVariant(
                    variants,
                    "state",
                    "googleDrivePreview"
                  )
                })}
              />
            </div>
          ) : null}
        </div>
      ) : null}
      {true ? (
        <div
          data-plasmic-name={"canvasDiv"}
          data-plasmic-override={overrides.canvasDiv}
          className={classNames(projectcss.all, sty.canvasDiv, {
            [sty.canvasDivnoFile]: hasVariant(variants, "noFile", "noFile"),
            [sty.canvasDivshowLevel]: hasVariant(
              variants,
              "showLevel",
              "showLevel"
            ),
            [sty.canvasDivstate_googleDrivePreview]: hasVariant(
              variants,
              "state",
              "googleDrivePreview"
            ),
            [sty.canvasDivstate_levels]: hasVariant(
              variants,
              "state",
              "levels"
            ),
            [sty.canvasDivstate_noteEditor]: hasVariant(
              variants,
              "state",
              "noteEditor"
            ),
            [sty.canvasDivstate_noteList]: hasVariant(
              variants,
              "state",
              "noteList"
            ),
            [sty.canvasDivstate_settings]: hasVariant(
              variants,
              "state",
              "settings"
            ),
            [sty.canvasDivstate_spaces]: hasVariant(
              variants,
              "state",
              "spaces"
            ),
            [sty.canvasDivstate_waitList]: hasVariant(
              variants,
              "state",
              "waitList"
            )
          })}
        />
      ) : null}
      {(hasVariant(variants, "state", "noteEditor") ? true : true) ? (
        <NoteViewer
          data-plasmic-name={"noteViewer"}
          data-plasmic-override={overrides.noteViewer}
          className={classNames("__wab_instance", sty.noteViewer, {
            [sty.noteViewerstate_noteEditor]: hasVariant(
              variants,
              "state",
              "noteEditor"
            )
          })}
        />
      ) : null}

      <div
        data-plasmic-name={"toastify"}
        data-plasmic-override={overrides.toastify}
        className={classNames(projectcss.all, sty.toastify, {
          [sty.toastifystate_noteEditor]: hasVariant(
            variants,
            "state",
            "noteEditor"
          )
        })}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "projectTitleEditor",
    "levelDisplay",
    "spaceDisplay",
    "toProjects",
    "projects",
    "logo",
    "pro",
    "subscription",
    "columns",
    "canvasSidebar",
    "noteList",
    "controlHelper",
    "grayMenuArea",
    "levelsMenu",
    "projectSettings",
    "noFileOptions",
    "fileUpload",
    "formats2",
    "createDemo",
    "waitlistForm",
    "googleDriveContainer",
    "googleDriveSheet",
    "canvasDiv",
    "noteViewer",
    "toastify"
  ],
  projectTitleEditor: ["projectTitleEditor"],
  levelDisplay: ["levelDisplay"],
  spaceDisplay: ["spaceDisplay"],
  toProjects: ["toProjects"],
  projects: ["projects", "logo", "pro"],
  logo: ["logo"],
  pro: ["pro"],
  subscription: ["subscription"],
  columns: ["columns", "canvasSidebar", "noteList", "controlHelper"],
  canvasSidebar: ["canvasSidebar"],
  noteList: ["noteList"],
  controlHelper: ["controlHelper"],
  grayMenuArea: [
    "grayMenuArea",
    "levelsMenu",
    "projectSettings",
    "noFileOptions",
    "fileUpload",
    "formats2",
    "createDemo",
    "waitlistForm",
    "googleDriveContainer",
    "googleDriveSheet"
  ],
  levelsMenu: ["levelsMenu"],
  projectSettings: ["projectSettings"],
  noFileOptions: ["noFileOptions", "fileUpload", "formats2", "createDemo"],
  fileUpload: ["fileUpload", "formats2"],
  formats2: ["formats2"],
  createDemo: ["createDemo"],
  waitlistForm: ["waitlistForm"],
  googleDriveContainer: ["googleDriveContainer", "googleDriveSheet"],
  googleDriveSheet: ["googleDriveSheet"],
  canvasDiv: ["canvasDiv"],
  noteViewer: ["noteViewer"],
  toastify: ["toastify"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  projectTitleEditor: typeof ProjectTitleEditor;
  levelDisplay: typeof TransparentDisplay;
  spaceDisplay: typeof TransparentDisplay;
  toProjects: "div";
  projects: "div";
  logo: typeof p.PlasmicImg;
  pro: "div";
  subscription: "div";
  columns: "div";
  canvasSidebar: typeof CanvasSidebar;
  noteList: typeof NoteList;
  controlHelper: typeof ControlHelper;
  grayMenuArea: "div";
  levelsMenu: typeof LevelsMenu;
  projectSettings: typeof ProjectSettings;
  noFileOptions: "div";
  fileUpload: "div";
  formats2: "div";
  createDemo: "div";
  waitlistForm: typeof WaitlistForm;
  googleDriveContainer: "div";
  googleDriveSheet: "div";
  canvasDiv: "div";
  noteViewer: typeof NoteViewer;
  toastify: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCanvasView__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCanvasView__VariantsArgs;
    args?: PlasmicCanvasView__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicCanvasView__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicCanvasView__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicCanvasView__ArgProps,
          internalVariantPropNames: PlasmicCanvasView__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicCanvasView__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCanvasView";
  } else {
    func.displayName = `PlasmicCanvasView.${nodeName}`;
  }
  return func;
}

export const PlasmicCanvasView = Object.assign(
  // Top-level PlasmicCanvasView renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    projectTitleEditor: makeNodeComponent("projectTitleEditor"),
    levelDisplay: makeNodeComponent("levelDisplay"),
    spaceDisplay: makeNodeComponent("spaceDisplay"),
    toProjects: makeNodeComponent("toProjects"),
    projects: makeNodeComponent("projects"),
    logo: makeNodeComponent("logo"),
    pro: makeNodeComponent("pro"),
    subscription: makeNodeComponent("subscription"),
    columns: makeNodeComponent("columns"),
    canvasSidebar: makeNodeComponent("canvasSidebar"),
    noteList: makeNodeComponent("noteList"),
    controlHelper: makeNodeComponent("controlHelper"),
    grayMenuArea: makeNodeComponent("grayMenuArea"),
    levelsMenu: makeNodeComponent("levelsMenu"),
    projectSettings: makeNodeComponent("projectSettings"),
    noFileOptions: makeNodeComponent("noFileOptions"),
    fileUpload: makeNodeComponent("fileUpload"),
    formats2: makeNodeComponent("formats2"),
    createDemo: makeNodeComponent("createDemo"),
    waitlistForm: makeNodeComponent("waitlistForm"),
    googleDriveContainer: makeNodeComponent("googleDriveContainer"),
    googleDriveSheet: makeNodeComponent("googleDriveSheet"),
    canvasDiv: makeNodeComponent("canvasDiv"),
    noteViewer: makeNodeComponent("noteViewer"),
    toastify: makeNodeComponent("toastify"),

    // Metadata about props expected for PlasmicCanvasView
    internalVariantProps: PlasmicCanvasView__VariantProps,
    internalArgProps: PlasmicCanvasView__ArgProps
  }
);

export default PlasmicCanvasView;
/* prettier-ignore-end */
